import React from 'react';

export default class Page8 extends React.Component {

    render() {

        const {pageData} = this.props;

        const selectOption = <>
            <option value="0">Select</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            </>;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>BOREDOM PRONENESS EXERCISE
                                            </div>
                                            <p>Boredom is the aversive state that occurs when we are not able to
                                                successfully engage
                                                attention with internal (e.g. thoughts or feelings) or external
                                                (e.g. environmental stimuli)
                                                information required for participating in satisfying activity.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>6</sup></a></p>
                                            <p>As a tool for identifying predisposition to boredom,
                                                Farmer &amp; Sundberg<a className="superscripttext"
                                                                        href="further_info.php?course=300"><sup>7</sup></a> devised
                                                the Boredom
                                                Proneness Scale, which has been included below. To find out your
                                                own relationship with boredom,
                                                look at the following statements and rank your affinity with
                                                them from 1 (not representative of
                                                yourself) to 7 (completely representative of yourself).</p>

                                            <div className="mobile-scroll">
                                                <table
                                                    className="ilead_v_sport tablesrink uiheading ilead_v_sport_new_task"
                                                    border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve " align="left" valign="top"
                                                            width="93%">Statement
                                                        </th>
                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="8%">Rank
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>In situations where I have to wait,
                                                            such as a line or queue, I get very restless.</p>
                                                        </td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="1"
                                                                        value={pageData?.Statement?.[1]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>Many people would say that I am a
                                                            creative or imaginative person.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="2"
                                                                        value={pageData?.Statement?.[2]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>It takes a lot of change and variety
                                                            to keep me really happy.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="3"
                                                                        value={pageData?.Statement?.[3]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>Among my friends, I am the one who
                                                            keeps doing something the longest.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="4"
                                                                        value={pageData?.Statement?.[4]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>I would like more challenging things
                                                            to do in life.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="5"
                                                                        value={pageData?.Statement?.[5]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>I often find myself at loose ends,
                                                            not knowing what to do.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="6"
                                                                        value={pageData?.Statement?.[6]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>Having to look at someone’s home
                                                            movies or travel slides bores me tremendously.</p>
                                                        </td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="7"
                                                                        value={pageData?.Statement?.[7]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>When I was young, I was often in
                                                            monotonous and tiresome situations. </p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="8"
                                                                        value={pageData?.Statement?.[8]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>I have so many interests I don’t have
                                                            time to do everything.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="9"
                                                                        value={pageData?.Statement?.[9]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>Many things I have to do are
                                                            repetitive and monotonous.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="10"
                                                                        value={pageData?.Statement?.[10]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>I have projects in mind all the time,
                                                            things to do.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="11"
                                                                        value={pageData?.Statement?.[11]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>I feel that I am working below my
                                                            abilities most of the time.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="12"
                                                                        value={pageData?.Statement?.[12]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>I often find myself with nothing to
                                                            do – time on my hands.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="13"
                                                                        value={pageData?.Statement?.[13]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>I often wake up with a new idea.</p>
                                                        </td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="14"
                                                                        value={pageData?.Statement?.[14]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>It takes more stimulation to get me
                                                            going than most people.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="15"
                                                                        value={pageData?.Statement?.[15]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>It is easy for me to concentrate on
                                                            my activities </p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="16"
                                                                        value={pageData?.Statement?.[16]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>I am often trapped in situations
                                                            where I have to do meaningless things. </p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="17"
                                                                        value={pageData?.Statement?.[17]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>Frequently when I am working I find
                                                            myself worrying about other things.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="18"
                                                                        value={pageData?.Statement?.[18]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>Much of the time I just sit around
                                                            doing nothing.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="19"
                                                                        value={pageData?.Statement?.[19]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>Unless I am doing something exciting,
                                                            even dangerous, I feel half-dead and dull.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="20"
                                                                        value={pageData?.Statement?.[20]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>In any situation I can usually find
                                                            something to do or see to keep me interested.</p>
                                                        </td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="21"
                                                                        value={pageData?.Statement?.[21]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>I am good at waiting patiently.</p>
                                                        </td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="22"
                                                                        value={pageData?.Statement?.[22]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>I am seldom excited about my
                                                            work. </p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="23"
                                                                        value={pageData?.Statement?.[23]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>I find it easy to entertain
                                                            myself.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="24"
                                                                        value={pageData?.Statement?.[24]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>Time always seems to be passing
                                                            slowly.</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="25"
                                                                        value={pageData?.Statement?.[25]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>I get a kick out of most things I
                                                            do.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="26"
                                                                        value={pageData?.Statement?.[26]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left" valign="center"
                                                            width="93%"><p>It seems that the same things are on
                                                            television or the movies all the time, I’m getting
                                                            old!</p></td>
                                                        <td className=" darkgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="27"
                                                                        value={pageData?.Statement?.[27]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left" valign="center"
                                                            width="93%"><p>It would be very hard for me to find
                                                            a job that is exciting enough.</p></td>
                                                        <td className="lightgreen ">
                                                            <span className="ilead-slect-box-blue select">
                                                                <select className="custom-dropdown small"
                                                                        name="28"
                                                                        value={pageData?.Statement?.[28]}
                                                                        onChange={this.props.handleChangePageData('Statement', true)}>
                                                                    {selectOption}
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="center"
                                                            width="93%"><p>Total</p></td>
                                                        <td className="darkgreen"><span className="mom_response"
                                                                                        id="momentam_response_total">
                                                            {pageData?.Statement && Object.values(pageData?.Statement).reduce(function(acc, val) { return acc + val; }, 0)}
                                                        </span>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>

                                            </div>
                                            <p>When you have worked through the questionnaire, simply add up the
                                                values of all your answers;
                                                this is your overall score. You can then use this to compare to
                                                the table we have designed
                                                overleaf based on the average values of others who use this
                                                test.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page9')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}